import axios from 'src/store/vue-axios/axios.js'

export default class Schools {
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // API ENDPOINTS ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

  // SCHOOLS -> /schools/${schoolUuid}*
  static schoolsUrl = (schoolUuid) => `/schools/${schoolUuid}`
  static schoolsExtendedUrl = (schoolUuid) => `/schools/${schoolUuid}?extended=1`
  static makeUsersUrl = (schoolUuid) => `/schools/${schoolUuid}/make-users`
  static contactPersonUrl = (schoolUuid) => `/schools/${schoolUuid}/contact-person`
  static downloadUsersUrl = (schoolUuid) => `/schools/${schoolUuid}/download-users`
  static sduiPartnersUrl = (schoolUuid) => `/schools/${schoolUuid}/sdui-partners`
  static partnersUrl = (schoolUuid, partnerUuid) => `/schools/${schoolUuid}/partners/${partnerUuid}`
  static channelsUrl = (schoolUuid) => `/schools/${schoolUuid}/channels`
  static statisticsUrl = (schoolUuid) => `/schools/${schoolUuid}/statistics`
  static duplicatedUsersUrl = (schoolUuid) => `/schools/${schoolUuid}/duplicated-users`
  static forgotEmailUrl = (schoolUuid) => `/schools/${schoolUuid}/forgotten-email`

  // ROLES -> /schools/${schoolUuid}/roles*
  static schoolsRolesUrl = (schoolUuid) => `/schools/${schoolUuid}/roles`
  static schoolsRolesSingleUrl = (schoolUuid, roleId) => `/schools/${schoolUuid}/roles/${roleId}`

  // ONBOARDING -> /schools/${schoolUuid}/onboarding*
  static onboardingUrl = (schoolUuid) => `/schools/${schoolUuid}/onboarding`
  static confirmOnboardingUrl = (schoolUuid) => `/schools/${schoolUuid}/onboarding/confirm`

  // USERS -> /schools/${schoolUuid}/users*
  static usersUrl = (schoolUuid) => `/schools/${schoolUuid}/users`
  static deletedUsersUrl = (schoolUuid) => `/schools/${schoolUuid}/users?filter=deleted`
  static archivedUsersUrl = (schoolUuid) => `/schools/${schoolUuid}/users?filter=archived`
  static deletionRequestUsersUrl = (schoolUuid) => `/schools/${schoolUuid}/users?filter=requested`

  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // API IMPLEMENTATIONS ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // SCHOOLS -> /schools/${schoolUuid}*
  static async getSchool (uuid) {
    return axios.get(this.schoolsUrl(uuid))
  }

  static async putSchool (school) {
    await axios.put(this.schoolsUrl(school.uuid), school)
  }

  static async getSchoolExtended (uuid) {
    const res = await axios.get(this.schoolsExtendedUrl(uuid))
    return res.data
  }

  static async getNumberDeletionRequests (schoolUuid) {
    const res = await axios.get(this.deletionRequestUsersUrl(schoolUuid))
    return res?.data?.filter((user) => user?.deletion_approved_at === null)?.length
  }

  static async postMakeUsers (uuid, payload) {
    return axios.post(this.makeUsersUrl(uuid), payload)
  }

  static async getContactPerson (schoolUuid) {
    return axios.get(this.contactPersonUrl(schoolUuid), { showMessages: false })
  }

  static async getPendingUsers (schoolUuid) {
    return axios.get(this.downloadUsersUrl(schoolUuid), { showMessages: false })
  }

  static async getSduiPartners (schoolUuid) {
    return axios.get(this.sduiPartnersUrl(schoolUuid))
  }

  static async deletePartner (schoolUuid, partnerUuid) {
    return axios.delete(this.partnersUrl(schoolUuid, partnerUuid))
  }

  static async postPartner (schoolUuid, partnerUuid) {
    return axios.post(this.partnersUrl(schoolUuid, partnerUuid), { hideSuccessMessages: true })
  }

  static async getStatistics (schoolUuid) {
    return axios.get(this.statisticsUrl(schoolUuid), { showMessages: false })
  }

  static async postForgotEmail (schoolUuid, payload, config) {
    return axios.post(this.forgotEmailUrl(schoolUuid), payload, config)
  }

  // ROLES -> /schools/${schoolUuid}/roles*
  static async getSchoolRoles (schoolUuid) {
    return axios.get(this.schoolsRolesUrl(schoolUuid))
  }

  static async postSchoolRole (schoolUuid, role) {
    return axios.post(this.schoolsRolesUrl(schoolUuid), role)
  }

  static async putSchoolRoleSingle (schoolUuid, role) {
    return axios.put(this.schoolsRolesSingleUrl(schoolUuid, role.id), role)
  }

  static async deleteSchoolRoleSingle (schoolUuid, roleId) {
    return axios.delete(this.schoolsRolesSingleUrl(schoolUuid, roleId))
  }

  // ONBOARDING -> /schools/${schoolUuid}/onboarding*
  static async getOnboarding (schoolUuid) {
    return axios.get(this.onboardingUrl(schoolUuid))
  }

  static async postConfirmOnboardingUrl (schoolUuid, payload) {
    return axios.post(this.confirmOnboardingUrl(schoolUuid), payload)
  }
}
